import {
  PerDiemFormDocument,
  PerDiemFormQuery,
  PerDiemRateConfigurationFragment,
} from 'generated/resources/graphql'

type CompaniesLegalEntity = NonNullable<
  PerDiemFormQuery['companies']['legalEntitiesConnection']['nodes']
>[number]

import { useQuery } from 'modules/core/hooks/useQuery'

export type PerDiemRateOption = { value: number; label: string }
export type PerDiemRateOptions = PerDiemRateOption[]

export type PerDiemRate = {
  id?: null | number
  rateConfigurationId: number | null
  units: number
  totalAmount: number
  rateAmount: number
  label: string
  currency: string
}
export type PerDiemRates = PerDiemRate[]

type UsePerDiemForm = {
  rateConfigurations: PerDiemRateConfigurationFragment[]
  legalEntities: Pick<CompaniesLegalEntity, 'id' | 'country'>[]
  loading: boolean
}

export const usePerDiemForm = (companyId: number, accessId: number): UsePerDiemForm => {
  const { data, loading } = useQuery(PerDiemFormDocument, {
    variables: { companyId, accessId },
  })
  return {
    loading,
    legalEntities: data?.companies.legalEntitiesConnection.nodes ?? [],
    rateConfigurations: data?.expenses.rateConfigurationsConnection.nodes ?? [],
  }
}
